// extracted by mini-css-extract-plugin
module.exports = {"replies":"tweet-replies_replies__Ig_qi","link":"tweet-replies_link__oDs_B","text":"tweet-replies_text__dpdnl"};